import { Component } from '@angular/core';

@Component({
    selector: 'app-whiteboard-tip',
    templateUrl: './whiteboard-tip.component.html',
    styleUrls: ['./whiteboard-tip.component.scss'],
    standalone: true
})
export class WhiteboardTipComponent {

}
